<template>
	<div class="add-product-type">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="
				productType.id ? $t('addProductType.edit') : $t('addProductType.add')
			"
			:visible.sync="dialogProductType"
			width="40%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<div v-loading="loadingForm" :element-loading-text="$t('common.request')">
				<el-form
					:label-position="labelPosition"
					:rules="rules"
					ref="productType"
					label-width="80px"
					:model="productType">
					<el-form-item :label="$t('addProductType.name')" prop="name">
						<el-input
							v-model="productType.name"
							:placeholder="$t('addProductType.pName')"
							autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item :label="$t('addProductType.notes')">
						<el-input
							type="textarea"
							:rows="4"
							v-model="productType.notes"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
				<el-button
					type="primary"
					:disabled="loadingForm"
					@click="submitForm('productType')"
					>{{ $t("common.definite") }}</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "AddProductType",
	props: {
		productType: Object,
		dialogProductType: Boolean,
	},
	data() {
		return {
			labelPosition: "top",
			rules: {
				name: [
					{
						required: true,
						message: this.$t("addProductType.pName"),
						trigger: "blur",
					},
				],
			},
			clear: false,
			loadingForm: false,
		};
	},
	mounted() {
		this.clear = false;
	},
	methods: {
		closeDialog() {
			this.clearValidate("productType");
			if (this.productType.id) {
				this.$toolUtil.clearForm(this.productType);
			} else {
				if (this.clear) {
					this.$toolUtil.clearForm(this.productType);
				}
			}
			this.cancel("");
		},
		openDialog() {},
		cancel(state, code) {
			this.$emit("cancel", false, state, code);
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loadingForm = true;
					let url = this.$url.ProductType.insert;
					let method = this.$method.post;
					if (this.productType.id) {
						url = this.$url.ProductType.update;
						method = this.$method.put;
					}
					this.$api
						.request(url, method, this.productType)
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.clear = true;
								this.cancel(this.productType.id ? "update" : "save");
							}
							this.loadingForm = false;
						})
						.catch(err => {
							this.$notify({
								title: this.$t("common.tip"),
								message: err.msg,
								type: "error",
							});
							this.loadingForm = false;
						});
				}
			});
		},
		// 清除表单校验
		clearValidate(formName) {
			this.$refs[formName].clearValidate();
		},
	},
};
</script>

<style lang="sass"></style>
